// extracted by mini-css-extract-plugin
export default {"line":"ListItem_line__6mm2A","fio":"ListItem_fio__pviOB"};